import React from 'react'
import _ from 'lodash'

/*
NOTE: This componet serves the function of a conversion functin for Expedition progress data. This is a temporary implementation.
Should be re-written when we decide to implement the actual expedition track progress board.
 */

const INTERACTABLES = {
	//NOTE: keys are the in-game id of the interactable
	0: { name: 'Drakon' },
	1: { name: 'Flittermouse' },
	2: { name: 'Kribbet' },
	3: { name: 'Ketryx' },
	4: { name: 'Fieren' },
	5: { name: 'Timpita' },
	6: { name: 'Water Station' },
	7: { name: 'Air Station' },
	8: { name: 'Coyote' },
	9: { name: 'Burrowing Owl' },
	10: { name: 'Desert Kangaroo Rat' },
	11: { name: 'Mule Deer' },
	12: { name: 'Red Fox' },
	13: { name: 'Prairie Dog' },
	14: { name: 'Jackrabbit' },
	15: { name: 'Gray Wolf' },
	16: { name: 'Wolverine' },
	17: { name: 'Lemming' },
	18: { name: 'Moose' },
	19: { name: 'Grizzly Bear' }
}

type ResultType = {
	className: string
	expedition: string
	students: []
	totalCardCount?: {}
	activeHypothesis?: {
		guess: string
		creator: string
		reason: []
		support: [{ card?: string; content?: string }]
	}
	success?: string
	needToKnow?: []
	known?: []
	hypothesis?: [
		{ guess: string; creator: string; reason?: []; support?: [card: string, content: string] }
	]
	evidences?: {}
	solutions?: { proposed?: []; testing?: []; tested?: []; submitted?: [] }
}

export const ExpeditionProgress = ({ groupInfo, playtestData }) => {
	const studentMap = new Map()
	groupInfo.students.forEach(student => studentMap.set(student.id, student.full_name))

	const beginExpedition = !_.isEmpty(playtestData.definition.expedition_data?.player_progress)

	if (beginExpedition) {
		var { active_hypothesis, cards } =
			playtestData.definition.expedition_data?.player_progress?.knowledge_archive

		var finalHP =
			playtestData.definition.expedition_data.player_progress.tracked_health_percentage
		var groupedCards = _.groupBy(cards, 'knowledge_type')
	}

	const getCreator = creatorId => studentMap.get(creatorId)
	const getVoteCounts = playerVotes => {
		const countedVotes = []

		Object.entries(playerVotes).forEach(([player, vote]) => {
			return vote === 'yea' && countedVotes.push(getCreator(player))
		})
		return countedVotes
	}
	const getCardCount = () => {
		const groupedCards = _.groupBy(cards, 'card_creator_id')
		let count = {}
		_.forEach(
			Object.entries(groupedCards),
			([creator, cards]) => (count[`${getCreator(creator)}`] = cards.length)
		)

		return count
	}
	const handleHypothesis = guess => {
		return {
			creator: studentMap.get(guess.card_creator_id),
			guess: guess.card_name,
			reason: guess.elements.map(ele => ele.reasoning),
			support: guess.attached_card_guids.map(evi => ({
				card: cards[evi].card_name,
				content: cards[evi].content
			}))
		}
	}

	const handleEvidence = evidences => {
		const groupedEvidence = _.groupBy(evidences, 'card_creator_id')
		let cardsByCreator = {}

		Object.entries(groupedEvidence).forEach(([creator, cards]: [string, [any]]) => {
			const formattedCard = cards.map(eviCard => {
				const { card_name: card, content, evidence_type: type, ...rest } = eviCard
				return { card, content, type }
			})
			cardsByCreator[`${getCreator(creator)}`] = formattedCard
		})

		return cardsByCreator
	}

	const handleSolution = solution => {
		const {
			treatment: card,
			card_creator_id: creatorId,
			player_votes: playerVotes,
			condition_a,
			condition_b,
			condition_type,
			supporting_evidence: supports,
			day_implemented: startDate,
			targets
		} = solution
		return {
			creator: getCreator(creatorId),
			card,
			condition: `${condition_a} ${
				condition_type !== 'Single' ? condition_type.toLowerCase() : ''
			} ${condition_b || ''}`,
			playerVotes: getVoteCounts(playerVotes),
			supports: (supports || []).map(supportId =>
				[cards[supportId].card_name, cards[supportId].content].join()
			),
			targets: targets.map(targetId => INTERACTABLES[targetId].name),
			startDate
		}
	}

	let result: ResultType = {
		className: groupInfo.className,
		expedition: groupInfo.expeditionName,
		students: groupInfo.students.map(student => student.full_name)
	}

	if (beginExpedition) {
		result = {
			...result,
			totalCardCount: getCardCount(),
			...(active_hypothesis && {
				activeHypothesis: handleHypothesis(cards[active_hypothesis])
			}),
			success:
				JSON.stringify(
					playtestData.definition.expedition_data?.simulation_result?.success
				) || 'incomplete',
			needToKnow: (groupedCards?.need_to_know || []).map(ntk => {
				const {
					card_name: card,
					card_creator_id: creatorId,
					player_votes: playerVotes
				} = ntk
				return {
					card,
					creator: getCreator(creatorId),
					playerVotes: getVoteCounts(playerVotes)
				}
			}),
			known: (groupedCards?.known || []).map(known => {
				const {
					card_name: card,
					card_creator_id: creatorId,
					player_votes: playerVotes,
					attached_card_guids: supports
				} = known

				return {
					card,
					creator: getCreator(creatorId),
					playerVotes: getVoteCounts(playerVotes),
					supports: supports.map(
						supportId => cards[supportId].content + cards[supportId].card_name
					)
				}
			}),
			hypothesis: (groupedCards?.hypothesis || []).map(guess => handleHypothesis(guess)),
			evidences: handleEvidence(groupedCards?.evidence || []),
			solutions: {
				proposed: (groupedCards?.solution_proposing || []).map(solution =>
					handleSolution(solution)
				),
				testing: (groupedCards?.solution_testing || []).map(solution =>
					handleSolution(solution)
				),
				tested: (groupedCards?.solution_tested || []).map(solution =>
					handleSolution(solution)
				),
				submitted: (groupedCards?.solution_reflection || []).map(solution =>
					handleSolution(solution)
				)
			}
		}
	}

	const styles = {
		basic: {
			fontFamily: 'Arial, sans-serif',
			fontSize: '13px'
		},
		sectionHeader: {
			fontFamily: 'Arial, sans-serif',
			fontSize: '22px',
			fontWeight: 'bold',
			margin: 0,
			padding: 0
		},
		sectionSubHeader: {
			fontFamily: 'Arial, sans-serif',
			fontSize: '18px',
			fontWeight: 'bold',
			margin: '16px 0 0 0',
			padding: 0
		},
		columnHeader: {
			fontFamily: 'Arial, sans-serif',
			fontSize: '15px',
			fontWeight: 'bold',
			margin: 0,
			padding: '0 4px'
		},
		columnSection: { fontFamily: 'Arial, sans-serif', marginBottom: '18px', marginLeft: '8px' },
		none: { fontFamily: 'Arial, sans-serif', padding: '0 6px' },
		notes: { fontFamily: 'Arial, sans-serif', display: 'block', fontSize: '12px', color: 'red' }
	}

	return (
		<div className='ExpeditionReport' style={styles.basic}>
			<h4 style={styles.sectionHeader}>
				<b>
					{result.className} / {result.expedition}
				</b>
			</h4>
			<p>Participating students: {result.students.join(', ')}</p>

			{!beginExpedition ? (
				<p>This group of student have not begin their expeditions experience yet...</p>
			) : (
				<>
					<section className='general' style={styles.basic}>
						<p className='EndState'>
							<b>Success status:</b> {result.success} <br />
							<b>Remaining HP:</b> {finalHP ? finalHP : 'NA'}
						</p>
						<p>
							<b>Total card counts:</b>
							<span style={styles.notes}>
								**this section only counts the total cards created by each student,
								it doesn't count voting or attaching evidences
							</span>
							{Object.entries(result.totalCardCount).map(
								([student, count]: [string, number]) => (
									<>
										<span>
											{student}:{count}
										</span>
										<br />
									</>
								)
							)}
						</p>
						{result?.activeHypothesis && (
							<div>
								<b>Chosen Hypothesis: {result?.activeHypothesis.guess}</b>
								<br />
								creator: <span>{result?.activeHypothesis.creator}</span>
								<br />
								reason: <span>{result?.activeHypothesis.reason.join(', ')}</span>
								<ul>
									{result?.activeHypothesis.support.map(support => (
										<li>{support.card + support.content}</li>
									))}
								</ul>
							</div>
						)}
					</section>

					<section className='All Cards'>
						<h4 style={styles.sectionHeader}>Full List of Cards</h4>
						<section className={'Knowledge'} style={styles.columnSection}>
							<h5 style={{ ...styles.sectionSubHeader, marginTop: 0 }}>
								Knowledge Cards
							</h5>
							<section className='NeedToKnow' style={styles.columnSection}>
								<h6 style={styles.columnHeader}>Need to Know Cards</h6>
								<KnowledgeCards knowledgeCards={result?.needToKnow} type='ntk' />
							</section>
							<section className='Known' style={styles.columnSection}>
								<h6 style={styles.columnHeader}>Known Cards</h6>
								{_.isEmpty(result?.known) ? (
									<span style={styles.none}>none</span>
								) : (
									<KnowledgeCards knowledgeCards={result?.known} type='known' />
								)}
							</section>

							<section className='Hypothesis' style={styles.columnSection}>
								<h6 style={styles.columnHeader}>Hypothesis Cards</h6>
								{_.isEmpty(result?.hypothesis) ? (
									<span style={styles.none}>none</span>
								) : (
									<ol>
										{(result?.hypothesis).map((hypothesis, ind) => {
											return (
												<li key={'hypothesis' + ind}>
													Hypothesis: <span>{hypothesis.guess}</span>
													<br />
													creator: <span>{hypothesis.creator}</span>
													<br />
													reason:{' '}
													<span>
														{(hypothesis?.reason || []).join(', ')}
													</span>
													<ul>
														{(hypothesis?.support || []).map(
															support => (
																<li>
																	{support.card + support.content}
																</li>
															)
														)}
													</ul>
												</li>
											)
										})}
									</ol>
								)}
							</section>
						</section>

						<section className='Evidences' style={styles.columnSection}>
							<h5 style={styles.sectionSubHeader}>Evidence Cards</h5>
							{_.isEmpty(result?.evidences) && <span style={styles.none}>none</span>}
							{Object.entries(result?.evidences).map(
								([creator, evidences]: [string, [any]]) => {
									return (
										<>
											<h6 style={styles.columnHeader}>By {creator}:</h6>
											<ol>
												{evidences.map((evidence, ind) => (
													<li key={'evidence' + ind}>
														<span>{evidence.type}</span>:{' '}
														<span>
															{evidence.card + evidence.content}
														</span>
													</li>
												))}
											</ol>
										</>
									)
								}
							)}
						</section>

						<section className='Solutions' style={styles.columnSection}>
							<h5 style={styles.sectionSubHeader}>
								<b>Solutions Cards</b>
							</h5>

							{Object.entries(result?.solutions).map(
								([solutionType, solution]: [string, []]) => {
									return (
										<section key={solutionType} style={styles.columnSection}>
											<h6 style={styles.columnHeader}>{solutionType}</h6>
											{_.isEmpty(solution) ? (
												<span style={styles.none}>none</span>
											) : (
												<>
													<span style={styles.notes}>
														**if condition is empty, solution will be
														applied to all.
													</span>
													<ol>
														{solution.map(
															(sol: {
																card: string
																targets: []
																condition?: string
																creator: string
																startDate: number
																supports?: []
																playerVotes?: []
															}) => (
																<li>
																	Method:{sol.card} <br />
																	Targets: {sol.targets.join(',')}
																	<br />
																	Condition:{' '}
																	{_.isEmpty(sol.condition)
																		? 'All'
																		: sol.condition}{' '}
																	<br />
																	Creator: {sol.creator} <br />
																	{sol.startDate > 0 && (
																		<>
																			Started testing on (in
																			game) day:{' '}
																			{sol.startDate} <br />
																		</>
																	)}
																	{!_.isEmpty(sol.supports) && (
																		<>
																			Support:{' '}
																			{sol.supports.join(',')}
																			<br />
																		</>
																	)}
																	{!_.isEmpty(
																		sol.playerVotes
																	) && (
																		<>
																			Votes:{' '}
																			{sol.playerVotes.join(
																				','
																			)}
																		</>
																	)}
																</li>
															)
														)}
													</ol>
												</>
											)}
										</section>
									)
								}
							)}
						</section>
					</section>
				</>
			)}
		</div>
	)
}

type KnowledgeCardsType = {
	knowledgeCards: []
	type: string
}

type KnowledgeType = {
	card: string
	creator: string
	playerVotes: []
	supports: []
}

const KnowledgeCards: React.FC<KnowledgeCardsType> = ({ knowledgeCards, type }) => {
	return (
		<ol>
			{(knowledgeCards || []).map((knowledge: KnowledgeType, ind: number) => (
				<li key={type + ind}>
					Card: <span>{knowledge.card}</span>
					<br />
					creator: <span>{knowledge.creator}</span>
					<br />
					votes: <span>{knowledge.playerVotes.join(', ')}</span>
					{!_.isEmpty(knowledge?.supports) && (
						<ul>
							{knowledge.supports.map(support => (
								<li>{support}</li>
							))}
						</ul>
					)}
				</li>
			))}
		</ol>
	)
}
